"use strict";

var _slicedToArray = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DOMException = require("domexception");

var StorageEvent = require("../generated/StorageEvent");

var idlUtils = require("../generated/utils"); // https://html.spec.whatwg.org/multipage/webstorage.html#the-storage-interface


var StorageImpl = /*#__PURE__*/function () {
  function StorageImpl(args, _ref) {
    var associatedWindow = _ref.associatedWindow,
        storageArea = _ref.storageArea,
        url = _ref.url,
        type = _ref.type,
        storageQuota = _ref.storageQuota;

    _classCallCheck(this, StorageImpl);

    this._associatedWindow = associatedWindow;
    this._items = storageArea;
    this._url = url;
    this._type = type;
    this._quota = storageQuota;
  }

  _createClass(StorageImpl, [{
    key: "_dispatchStorageEvent",
    value: function _dispatchStorageEvent(key, oldValue, newValue) {
      var _this = this;

      return this._associatedWindow._currentOriginData.windowsInSameOrigin.filter(function (target) {
        return target !== _this._associatedWindow;
      }).forEach(function (target) {
        return target.dispatchEvent(StorageEvent.create(["storage", {
          bubbles: false,
          cancelable: false,
          key: key,
          oldValue: oldValue,
          newValue: newValue,
          url: _this._url,
          storageArea: target["_" + _this._type]
        }]));
      });
    }
  }, {
    key: "key",
    value: function key(n) {
      if (n >= this._items.size) {
        return null;
      }

      return _toConsumableArray(this._items.keys())[n];
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      if (this._items.has(key)) {
        return this._items.get(key);
      }

      return null;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      var oldValue = this._items.get(key) || null;

      if (oldValue === value) {
        return;
      } // Concatenate all keys and values to measure their length against the quota


      var itemsTotalLength = key.length + value.length;

      var _iterator = _createForOfIteratorHelper(this._items),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              curKey = _step$value[0],
              curValue = _step$value[1];

          // If the key already exists, skip it as it will be set to the new value instead
          if (key !== curKey) {
            itemsTotalLength += curKey.length + curValue.length;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (itemsTotalLength > this._quota) {
        throw new DOMException("The ".concat(this._quota, "-code unit storage quota has been exceeded."), "QuotaExceededError");
      }

      setTimeout(this._dispatchStorageEvent.bind(this), 0, key, oldValue, value);

      this._items.set(key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      if (this._items.has(key)) {
        setTimeout(this._dispatchStorageEvent.bind(this), 0, key, this._items.get(key), null);

        this._items.delete(key);
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this._items.size > 0) {
        setTimeout(this._dispatchStorageEvent.bind(this), 0, null, null, null);

        this._items.clear();
      }
    }
  }, {
    key: "length",
    get: function get() {
      return this._items.size;
    }
  }, {
    key: idlUtils.supportedPropertyNames,
    get: function get() {
      return this._items.keys();
    }
  }]);

  return StorageImpl;
}();

module.exports = {
  implementation: StorageImpl
};